import { render, staticRenderFns } from "./ClcReportAntiquityDashboard.vue?vue&type=template&id=d5b3bb7a&"
import script from "./ClcReportAntiquityDashboard.vue?vue&type=script&lang=js&"
export * from "./ClcReportAntiquityDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ClcReportAntiquityDashboard.vue?vue&type=style&index=0&id=d5b3bb7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports